// extracted by css-extract-rspack-plugin
export default {"componentStackContainer":"componentStackContainer-cJBfy0","componentStack":"componentStack-YHnFwM"};